import React from 'react';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { LoadingPost } from './components/LoadingPost/LoadingPost';
import { Text } from '../CommonComponents/OPL/Text/Text';

export const NewsfeedLoading = () => (
  <Box as="ol" display="flex" flexDirection="column" p="0" css="list-style-type: none">
    <Text textTransform="uppercase" color="neutral.500" fontWeight={600} mb="16">
      Featured
    </Text>

    <LoadingPost />

    <Text textTransform="uppercase" color="neutral.500" fontWeight={600} mb="16">
      News
    </Text>

    <LoadingPost />

    <LoadingPost />

    <LoadingPost />
  </Box>
);
